import { render, staticRenderFns } from "./radialChart.vue?vue&type=template&id=a25a38ba&"
import script from "./radialChart.vue?vue&type=script&lang=js&"
export * from "./radialChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports